import React from 'react';
import toast from 'react-hot-toast';
import useApi from '../useApi';
import { IBillingCycleRes } from './index.type';

const useGetBillingCycle = ({ patientId }: { patientId?: string }) => {
  const [billingCycleData, setBillingCycleData] = React.useState<IBillingCycleRes>();
  const { loading: billingCycleLoading, makeApiCall } = useApi({
    url: '', 
    method: 'GET',
  });


  
  React.useEffect(() => {
    setBillingCycleData(undefined);
  }, [patientId]);

const getBillingCycleData = React.useCallback(async () => {
    if (!patientId) return;

    const { response, error } = await makeApiCall<undefined, IBillingCycleRes>(
      undefined,
      `/RTM/billing-cycle/current?patientId=${patientId}`
    );

    if (response?.status === 'success') {
      setBillingCycleData(response);
      return response;
    } else if (response?.status === 'fail') {
      setBillingCycleData(undefined);
    } else if (error) {
      setBillingCycleData(undefined);
      toast.error(
        'Something went wrong while fetching billing cycle. Please try again later.'
      );
    }
  }, [patientId, makeApiCall]);


  return {
    billingCycleData,
    getBillingCycleData,
    billingCycleLoading,
  };
};

export default useGetBillingCycle;
